import { Header } from 'lego-on-react';

const LegoHeader = Header;

export default LegoHeader;
